import { gql } from "@apollo/client";

export const GET_CAGES_FOR_SITE = gql`
  query GetCagesForSite($siteId: ID!) {
    cagesForSite(siteId: $siteId) {
      id
      siteId
      name
      position
    }
  }
`;
